import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalConfig } from 'src/app/models/modal.config';
import { AlertService } from 'src/app/services/alert.service';
import { PreCheckoutService } from 'src/app/services/pre-checkout.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { Utilitarios } from 'src/app/shared/utilitarios';
import { PreCheckoutQuery } from 'src/app/state/pre-checkout.query';
import { StateService } from 'src/app/state/state.service';
import { PreCheckoutViagemService, Values } from '../pre-checkout-viagem.service';

@Component({
  selector: 'app-pre-checkout-viagem-sem-rota',
  templateUrl: './pre-checkout-viagem-sem-rota.component.html',
  styleUrls: ['./pre-checkout-viagem-sem-rota.component.css']
})
export class PreCheckoutViagemSemRotaComponent implements OnInit {

  cdsOrigem: Array<any> = [];
  itemSelected: any = {id:0, name:""};
  translation: any;
  tentativa: number = 0;
  usuarioBloqueado: boolean = false;
  sendMail: boolean = false;
  
  modalConfig: ModalConfig = { 
    modalTitle: ""
  };
  @ViewChild('modalCadastroViagem') private modalCadastroViagemComponent: ModalComponent

  constructor(
    private preCheckoutService: PreCheckoutService,
    private translate: TranslateService,
    private preCheckoutQuery: PreCheckoutQuery,
    private stateService: StateService,
    private alertService: AlertService,
    private router: Router,
    private viagemService: PreCheckoutViagemService
  ) { }

  openModalCadastroViagem() {
    this.modalConfig.modalTitle = "Aviso";
    this.modalConfig.closeButtonLabel = "Sim";
    this.modalConfig.dismissButtonLabel = "Não";
    this.modalConfig.shouldClose = this.onSalvar.bind(this);
    this.modalConfig.onDismiss = this.onCancelar.bind(this);

    return this.modalCadastroViagemComponent.open();
  }

  onSalvar() {
    this.viagemService.setValue(new Values(this.itemSelected.id));
    this.stateService.updateOriginCd(this.itemSelected.name);
    this.sendMail = true;
    return true;
  }

  onCancelar(){
    this.alertService.alertWarning("Não foi localizado nenhuma SM para o CPF e CD de origem informado, tente novamente!", null);
    this.tentativasLimiteBloqueio(function(){
      this.bloquearMotorista();
      this.usuarioBloqueado = true;
    }.bind(this));
  }

  bloquearMotorista(){
    this.preCheckoutQuery.cpf$.subscribe((cpf)=>{
      this.preCheckoutService.bloquearMotorista(cpf)
        .subscribe(
          (result) => {
            if(result){
              let message = "Você excedeu o limite máximo de 3 tentativas!\n";
              message+="Pré-checkout reprovado!";
              this.alertService.alertWarning(message, null);
            }
          },
          (err) => {
            this.internalError(null);
          }
        );
    });
  }

  tentativasLimiteBloqueio(callBack: any)
  {
    this.tentativa = Utilitarios.tentativasLimiteBloqueio(this.tentativa, callBack);
  }

  existeSM(callBack1: any, callBack2: any){
    this.preCheckoutQuery.cpf$.subscribe((cpf)=>{
      this.preCheckoutService.getViagemByCpfOrigem(cpf, this.itemSelected.id)
      .subscribe(
        (result) => {
          if(result.data_inicio){
            this.alertService.alertWarning("Viagem em trânsito, não e permitido realizar o pré-checkout, favor contactar o Glog!", null);
            this.tentativasLimiteBloqueio(function(){
              this.bloquearMotorista();
              this.usuarioBloqueado = true;
            }.bind(this));
          }
          else if(!result.cpf || (result.cpf != cpf)){
            if(callBack1)
              callBack1();
          }
          else{
            if(callBack2)
              callBack2(result);
          }
        },
        (err) => {
          this.internalError("Ocorreu um erro ao tentar recuperar viagem, tente novamente!");
        }
      );
    });
  }

  prosseguir(){
    if(this.itemSelected.id)
    {
      this.existeSM(function(){
        this.openModalCadastroViagem();
      }.bind(this), function(obj){
        //Limpa alert
        this.alertService.limpaAlertMessage();
        this.stateService.updateSm(obj.sm);
        //Marca como concluído o estágio de viagem
        this.stateService.updateStageViagem(true);
        Utilitarios.NEXT_LEVEL="veiculo";
        this.router.navigate(['/veiculo']);
      }.bind(this));
    }
  }

  populaCdsOrigem(descricao: string = null){
    this.preCheckoutService.getCds(true, descricao)
    .subscribe(
      (result) => {
        if(result)
        {
          this.cdsOrigem = [];
          
          for(let cd of result.content)
          {
            let obj = {id:cd.id,name:cd.descricao};
            this.cdsOrigem.push(obj);
          }
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar recuperar CDs de origem, tente novamente!");
      }
    );
  }

  onChangeSearch(descricao: string)
  {
    this.populaCdsOrigem(descricao);
  }

  ngOnInit(): void {
    //Limpa mensagem ao iniciar o componente
    this.alertService.limpaAlertMessage();
    
    this.translate.get("preCheckout").subscribe((res) => {
      this.translation = res;
    });

    this.populaCdsOrigem();
  }

  internalError(err){
    this.alertService.alertDanger(err || this.translation.internalError, null);
  }
}